<script>
import { defineComponent } from "vue";
import SidebarRouteLink from "@kit/components/SidebarRouteLink.vue";
import NavMainSearch from "@kit/components/NavMainSearch.vue";
import SideNavDrawerBase from "@kit/components/SideNavDrawerBase.vue";
import { searchWidgetMobile, sideDrawer } from "@project/themes";
import { getCurrentYear } from "@kit/utils/Formats"

export default defineComponent({
  name: "SizeNavDrawer",
  setup() {
    return { searchWidgetMobile, sideDrawer, getCurrentYear };
  },
  components: {
    SideNavDrawerBase,
    SidebarRouteLink,
    NavMainSearch,
  },
});
</script>

<style>
.side-nav-1 {
  font-size: 25px;
  color: white;
}

.side-nav-1 > a {
  color: white;
  transition: 0.3s color linear;
}
.side-nav-1 > a:hover {
  color: white;
}
.side-nav-1 > a:visited {
  color: #eeeeee;
}

@media (max-width: 960px) {
}

.rvit-side-nav-drawer {
  background: linear-gradient(90deg,rgba(201, 77, 52, 1) 0%, rgba(171, 38, 12, 1) 100%);
  opacity: 1;
}
/* 
.rvit-side-nav-drawer-vertical-repeater {
  width:10% !important;
  top:0px !important;
  bottom:0px !important;
  left:80%;
  top:0px;
  background-image: url('/cms-static-assets/2026/03/RVIT-Vertical-Repeater_white.png');
  background-repeat:repeat-y;
  background-size: contain;
  opacity: 0.2;
  border: 1px solid green;
} */

</style>

<template>
  <SideNavDrawerBase :theme="sideDrawer">
    <template #nav-items="{ active }">

      <h1 class="sb sb-text" style="color:white; margin-top:30px;">Round Valley Indian Tribes</h1>

      <h3 class="sb sb-text" style="color:white; margin-top:30px;">General Info</h3>

      <div class="sb sb-v side-nav-1">
        <SidebarRouteLink to="/">Home</SidebarRouteLink>
      </div>
      <div class="sb sb-v side-nav-1">
        <SidebarRouteLink to="/government/documents-forms">Forms</SidebarRouteLink>
      </div>
      <div class="sb sb-v side-nav-1">
        <SidebarRouteLink to="/about/about-us">About Us</SidebarRouteLink>
      </div>
      <div class="sb sb-v side-nav-1">
        <SidebarRouteLink to="/jobs-rvit/jobs-general-information">General Information</SidebarRouteLink>
      </div>

      <h3 class="sb sb-text" style="color:white; margin-top:30px;">Jobs</h3>

      <div class="sb sb-v side-nav-1">
        <SidebarRouteLink to="/job-categories/round-valley-indian-tribes-jobs">RVIT Jobs</SidebarRouteLink>
      </div>
      <div class="sb sb-v side-nav-1">
        <SidebarRouteLink to="/job-categories/round-valley-indian-health-center-inc-jobs">RVIHC Jobs</SidebarRouteLink>
      </div>
      <div class="sb sb-v side-nav-1">
        <SidebarRouteLink to="/job-categories/round-valley-indian-housing-authority-jobs">RVIHA Jobs</SidebarRouteLink>
      </div>
      <div class="sb sb-v side-nav-1">
        <SidebarRouteLink to="/job-categories/hidden-oaks-casino-jobs">Casino Jobs</SidebarRouteLink>
      </div>

      <h3 class="sb sb-text" style="color:white; margin-top:30px;">News and Events</h3>

      <div class="sb sb-v side-nav-1">
        <SidebarRouteLink to="/news">RVIT News</SidebarRouteLink>
      </div>
      <div class="sb sb-v side-nav-1">
        <SidebarRouteLink to="/events/observed-holidays">Observed Holidays</SidebarRouteLink>
      </div>

      <h3 class="sb sb-text" style="color:white; margin-top:30px;">Programs</h3>

      <div class="sb sb-v side-nav-1">
        <SidebarRouteLink to="/programs/program-directory">Program Directory</SidebarRouteLink>
      </div>
      <div class="sb sb-v side-nav-1">
        <SidebarRouteLink to="/program-directory/child-care">Child Care</SidebarRouteLink>
      </div>
      <div class="sb sb-v side-nav-1">
        <SidebarRouteLink to="/program-directory/environmental-protection-agency">Environmental Protection Agency</SidebarRouteLink>
      </div>
      <div class="sb sb-v side-nav-1">
        <SidebarRouteLink to="/program-directory/head-start">Head Start</SidebarRouteLink>
      </div>
      <div class="sb sb-v side-nav-1">
        <SidebarRouteLink to="/program-directory/icwa">ICWA</SidebarRouteLink>
      </div>
      <div class="sb sb-v side-nav-1">
        <SidebarRouteLink to="/program-directory/nadvsap-dv">NADVSAP (DV)</SidebarRouteLink>
      </div>
      <div class="sb sb-v side-nav-1">
        <SidebarRouteLink to="/program-directory/natural-resources-department">Natural Resources Department</SidebarRouteLink>
      </div>
      <div class="sb sb-v side-nav-1">
        <SidebarRouteLink to="/program-directory/real-estate-department">Real Estate Department</SidebarRouteLink>
      </div>
      <div class="sb sb-v side-nav-1">
        <SidebarRouteLink to="/program-directory/roads-transportation-department">Roads/Transportation Department</SidebarRouteLink>
      </div>
      <div class="sb sb-v side-nav-1">
        <SidebarRouteLink to="/program-directory/senior-center">Senior Center</SidebarRouteLink>
      </div>
      <div class="sb sb-v side-nav-1">
        <SidebarRouteLink to="/program-directory/tribal-historic-preservation-office">Tribal Historic Preservation Office</SidebarRouteLink>
      </div>
      <div class="sb sb-v side-nav-1">
        <SidebarRouteLink to="/program-directory/tribal-police">Tribal Police</SidebarRouteLink>
      </div>
      <div class="sb sb-v side-nav-1">
        <SidebarRouteLink to="/program-directory/water-association">Water Association</SidebarRouteLink>
      </div>
      <div class="sb sb-v side-nav-1">
        <SidebarRouteLink to="/program-directory/7-tribes-rock-quarry">7 Tribes Rock Quarry</SidebarRouteLink>
      </div>

      <h3 class="sb sb-text" style="color:white; margin-top:30px;">Enterprises</h3>

      <div class="sb sb-v side-nav-1">
        <SidebarRouteLink to="/enterprises/enterprises-info">Enterprise Info</SidebarRouteLink>
      </div>

      <div class="sb sb-v side-nav-1">
        <a href="https://www.facebook.com/hiddenoaksconveniencestore/" class="sb sb-text">Hidden Oaks Convenience Store</a>
      </div>

      <div class="sb sb-v side-nav-1">
        <a href="https://www.goldenoaksmotel.com/" class="sb sb-text">Golden&nbsp;Oaks Motel</a>
      </div>

      <div class="sb sb-v side-nav-1">
        <a href="https://hiddenoakscasino.com/" class="sb sb-text">Hidden Oaks Casino</a>
      </div>

      <h3 class="sb sb-text" style="color:white; margin-top:30px;">Government</h3>

      <div class="sb sb-v side-nav-1">
        <SidebarRouteLink to="/government/tribal-council">Tribal Council</SidebarRouteLink>
      </div>
      <div class="sb sb-v side-nav-1">
        <SidebarRouteLink to="/government/tribal-administration">Tribal Administration</SidebarRouteLink>
      </div>
      <div class="sb sb-v side-nav-1">
        <SidebarRouteLink to="/government/tribal-court">Tribal Court</SidebarRouteLink>
      </div>
      <div class="sb sb-v side-nav-1">
        <SidebarRouteLink to="/government/constitution">Constitution</SidebarRouteLink>
      </div>
      <div class="sb sb-v side-nav-1">
        <SidebarRouteLink to="/government/documents-forms">Documents &amp; Forms</SidebarRouteLink>
      </div>
      <div class="sb sb-v side-nav-1">
        <SidebarRouteLink to="/government/agendas">Agendas</SidebarRouteLink>
      </div>
      <div class="sb sb-v side-nav-1">
        <SidebarRouteLink to="/government/minutes">Minutes</SidebarRouteLink>
      </div>
      <div class="sb sb-v side-nav-1">
        <SidebarRouteLink to="/government/committees-boards">Committees &amp; Boards</SidebarRouteLink>
      </div>
      <div class="sb sb-v side-nav-1">
        <SidebarRouteLink to="/contact-us">Contact</SidebarRouteLink>
      </div>

      <!-- <NavMainSearch :theme="searchWidgetMobile" :active="active" /> -->
      <div class="sb sb-v side-nav-1" style="font-size:0.7rem;">
        © {{ getCurrentYear() }} RVIT
      </div>

      <!-- <div style="z-index:0;" class="sb sb-abox rvit-side-nav-drawer-vertical-repeater"></div> -->

    </template>
  </SideNavDrawerBase>
</template>
